export const isEmptyObject = (obj: any): boolean => !Object.keys(obj).length;
